import Link from 'next/link';
import Image from 'next/image';

export default function Logo(props) {
  return (
    <Link href="/" className="flex items-center flex-none" aria-label="Logo">
      {props.fromFooter && (
        <Image
          src="/images/logo.webp"
          width={100}
          height={100}
          alt="Logo dott.ssa Angela Formisano"
        />
      )}
      {!props.fromFooter && (
        <Image
          src="/images/logo.webp"
          width={60}
          height={60}
          alt="Logo dott.ssa Angela Formisano"
        />
      )}
    </Link>
  );
}
